/** @jsx jsx */
import { jsx } from '@emotion/core';
import cmsUtils from '../../cms/utils/cmsUtils';
import { useEffect } from 'react';

export function WidgetEmbed(props) {
    const item = props.item;
    const cssClass = props.cssClass;
    const code = cmsUtils.payload(item, 'Code') || '';

    useEffect(() => {
        // Find all script tags in the code and execute them
        const container = document.getElementById(`widget-container-${item.itemId}`);
        if (container) {
            // First render the HTML
            container.innerHTML = code;
            
            // Then find and execute all scripts
            const scripts = container.querySelectorAll('script');
            scripts.forEach(oldScript => {
                const newScript = document.createElement('script');
                
                // Copy all attributes
                Array.from(oldScript.attributes).forEach(attr => {
                    newScript.setAttribute(attr.name, attr.value);
                });
                
                // Copy inline script content
                if (oldScript.innerHTML) {
                    newScript.innerHTML = oldScript.innerHTML;
                }
                
                // Replace old script with new one to execute it
                oldScript.parentNode.replaceChild(newScript, oldScript);
            });
        }
    }, [code, item.itemId]);

    return (
        <div className={cssClass} id={item.anchorName}>
            <div id={`widget-container-${item.itemId}`}></div>
        </div>
    );
}